import clsx from 'clsx';
import { PHASE_META, type PlatoonPhase } from '../types/domain';

// Single source of phase presentation — always reads PHASE_META (no color literals).
export default function PhaseChip({
  phase,
  size = 'sm',
}: {
  phase: PlatoonPhase;
  size?: 'sm' | 'xs';
}) {
  const meta = PHASE_META[phase];
  if (!meta) return null;
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full font-semibold whitespace-nowrap',
        size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs'
      )}
      style={{
        color: meta.color,
        backgroundColor: `${meta.color}22`,
        border: `1px solid ${meta.color}55`,
      }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: meta.color }} />
      {meta.label}
    </span>
  );
}
